import React, { Component } from 'react';
import InsertDriveFile from '@material-ui/icons/DescriptionOutlined';
import { Grid, Popper, Typography } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';
import Autocomplete from '@material-ui/lab/Autocomplete';
import debounce from 'lodash/debounce';

/*
This component supports case autocomplete selector
props:
initCase: {id, email, last_name, first_name} NOTE: null will show current case
update: callback, used to update father's case value
 */

class CaseAutoComplete extends Component {
    constructor(props) {
        super(props);

        this.initCase = null;

        if (this.props.initCase) {
            this.initCase = this.props.initCase;
        }

        this.state = {
            caseObj: this.initCase,
            caseOptions: [],
        };

        console.log("INIT>>>>>>>>>>.");

        // set current case as default
        this.props.update(this.initCase);

        // value changing may invoke change and inputChange at the same time.
        // This variable is used to block some useless inputChange events
        this.block = false;

        this.handleFocusout = this.handleFocusout.bind(this);
        this.handleAutoChange = this.handleAutoChange.bind(this);
        this.handleAutoInputChange = this.handleAutoInputChange.bind(this);
        this.handleAutoInputThrottled = debounce(this.handleAutoInputChange, 200);
    }

    render() {
        const {
            caseObj,
            caseOptions,
        } = this.state;

        console.log(caseOptions);

        const acPopper = function (props) {
            return (<Popper {...props} style={{ width: 'auto', minWidth: '300px' }} placement='bottom-start' />)
        };

        return (
            <Autocomplete
                style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                value={caseObj}
                onChange={this.handleAutoChange}
                onBlur={this.handleFocusout}
                onInputChange={this.handleAutoInputThrottled}
                options={caseOptions}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.number ? option.number : ""}
                filterOptions={(x) => x}
                PopperComponent={acPopper}
                renderInput={(params) => (
                    <TextField {...params} margin="dense" variant="outlined" label="Input the case number" fullWidth />
                )}
                renderOption={(option) => {
                    return (
                        <Grid container alignItems="center">
                            <Grid item style={{ marginRight: 10 }}>
                                <InsertDriveFile />
                            </Grid>
                            <Grid item xs>
                                {option.number}
                                <Typography variant="body2" color="textSecondary">
                                    {option.client.individual ? option.client.individual.first_name + " " + option.client.individual.last_name : option.client.corporation.name}
                                </Typography>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        );
    }
    componentDidUpdate(prevProps) {
        if (this.props.initCase !== prevProps.initCase) {
            const initCase = this.props.initCase;
            if (initCase) {
                this.initCase = initCase;
                this.setState(() => ({
                    caseObj: initCase
                }))
            }
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    // block request after the focusout event
    handleFocusout() {
        this.block = true;
        this.setState(() => ({
            caseOptions: [],
        }));
    }

    handleAutoChange(e, value) {
        console.log(value);

        // only happens when clearing all the inputs
        if (value === null) {
            return;
        }

        this.block = true;
        // update the father's value
        this.props.update(value);
        this.setState(() => ({
            caseObj: value,
        }));
    }

    handleAutoInputChange(e, value) {
        console.log(value);

        if (this.block) {
            this.block = false;
            return;
        }

        // simply clear the caseOptions if the input is empty
        if (value === null || value === "") {
            this.setState(() => ({
                caseOptions: [],
            }));
            return;
        }


        // TODO: this request uses a wrong API, needs a correct one.
        // let params = {
        //     office: null,
        //     page_index: 1,
        //     page_size: 1000,
        //     username: value
        // };
        const params = {
            search_content: value,
        }
        instance.get(BASE_URL + 'case/fuzzy_matching', { params }).then((res) => {
            let cases = res.data.data;
            this.setState(() => ({
                caseOptions: cases,
            }));
        }).catch((err) => {
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }

}

export default CaseAutoComplete;